import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Panel from "../components/common/Panel";
import Seo from "../components/common/Seo";
import { listPosts } from "../data/blogPosts";
import { t } from "../i18n/messages";
import { buildPath } from "../utils/routing";
import { localeContent } from "../utils/localeContent";

export default function BlogListPage({ locale }) {
  const [keyword, setKeyword] = useState("");
  const [topic, setTopic] = useState("all");

  const posts = useMemo(() => {
    return listPosts()
      .map((post) => ({ post, content: localeContent(post.locales, locale) }))
      .filter(({ post, content }) => {
        const matchKeyword =
          !keyword || `${content?.title || ""} ${content?.excerpt || ""}`.toLowerCase().includes(keyword.toLowerCase());
        const matchTopic = topic === "all" || post.topic === topic;
        return matchKeyword && matchTopic;
      });
  }, [keyword, topic, locale]);

  return (
    <>
      <Seo
        locale={locale}
        title={`Chronos Arte Node | ${t(locale, "navBlog")}`}
        description={t(locale, "blogDesc")}
        path={buildPath(locale, "blog")}
      />

      <Panel className="blog-list-filter-panel" title={t(locale, "blogTitle")} description={t(locale, "blogDesc")}>
        <div className="blog-list-filter-shell">
          <div className="form-grid blog-list-controls">
            <label>
              {t(locale, "blogSearch")}
              <input value={keyword} onChange={(e) => setKeyword(e.target.value)} placeholder={t(locale, "blogSearchPlaceholder")} />
            </label>
            <label>
              {t(locale, "blogTopic")}
              <select value={topic} onChange={(e) => setTopic(e.target.value)}>
                <option value="all">{t(locale, "blogTopicAll")}</option>
                <option value="rwa">{t(locale, "blogTopicRwa")}</option>
                <option value="market">{t(locale, "blogTopicMarket")}</option>
                <option value="ops">{t(locale, "blogTopicOps")}</option>
              </select>
            </label>
          </div>

          <div className="blog-list-status-row">
            <span className="blog-list-count-chip">{posts.length} {t(locale, "blogListCount")}</span>
          </div>
        </div>
      </Panel>

      <Panel className="blog-list-results-panel" title={t(locale, "blogListTitle")} description={`${posts.length} ${t(locale, "blogListCount")}`}>
        {posts.length ? (
          <div className="card-grid blog-post-grid">
            {posts.map(({ post, content }, index) => (
                <Link
                  key={post.id}
                  className={`card-link blog-post-card ${index % 2 ? "is-alt" : ""}`}
                  to={buildPath(locale, `blog/${post.id}`)}
                >
                  <div className="blog-post-card-head">
                    <p className="pill blog-post-topic">{post.topic}</p>
                    <span className="blog-post-read">{post.readMinutes} {t(locale, "blogMinutes")}</span>
                  </div>

                  <h3 className="blog-post-title">{content?.title || post.id}</h3>
                  <p className="blog-post-excerpt">{content?.excerpt || ""}</p>

                  <p className="blog-post-meta">{post.publishDate} · {post.author}</p>
                </Link>
            ))}
          </div>
        ) : (
          <div className="empty-state">{t(locale, "blogNoResults")}</div>
        )}
      </Panel>
    </>
  );
}
